import { isDateValid, isDayInRange } from './common/dateUtils.js';

/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getFormattedDateString(date, props) {
  var _props$minDate, _props$maxDate;

  var ignoreRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (date == null) {
    return "";
  } else if (!isDateValid(date)) {
    return props.invalidDateMessage;
  } else if (ignoreRange || isDayInRange(date, [(_props$minDate = props.minDate) !== null && _props$minDate !== void 0 ? _props$minDate : null, (_props$maxDate = props.maxDate) !== null && _props$maxDate !== void 0 ? _props$maxDate : null])) {
    return props.formatDate(date, props.locale);
  } else {
    return props.outOfRangeMessage;
  }
}

export { getFormattedDateString };
//# sourceMappingURL=dateFormat.js.map
